"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsNavigation = void 0;
var react_1 = __importDefault(require("react"));
var Navigation_1 = __importStar(require("Common/Navigation/Navigation"));
var TrialMessage_1 = __importDefault(require("Common/Trial/TrialMessage"));
var OpenBrandSetup_1 = __importDefault(require("DreamCoat/BrandSetUp/OpenBrandSetup"));
var mobx_react_1 = require("mobx-react");
exports.default = (function (mountReactComponent, trial, initSubscription, telemetry, projectLimit, projectLiveLimit, user, $state, invoke, publicApiBaseUrl, rolesService) {
    return mountReactComponent(react_1.default.createElement(SettingsNavigation, { trial: trial, initSubscription: initSubscription, telemetry: telemetry, projectLimit: projectLimit, projectLiveLimit: projectLiveLimit, user: user, "$state": $state, openBrandSetup: invoke(OpenBrandSetup_1.default), publicApiBaseUrl: publicApiBaseUrl, rolesService: rolesService }));
});
var SettingsNavigation = (function (_super) {
    __extends(SettingsNavigation, _super);
    function SettingsNavigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsNavigation.prototype.render = function () {
        return (react_1.default.createElement(Navigation_1.default, { pageName: Navigation_1.PageName.Settings, user: this.props.user, "$state": this.props.$state, openBrandSetup: this.props.openBrandSetup, publicApiBaseUrl: this.props.publicApiBaseUrl, telemetry: this.props.telemetry, rolesService: this.props.rolesService },
            this.renderItems(),
            this.renderMessage()));
    };
    SettingsNavigation.prototype.renderItems = function () {
        return (react_1.default.createElement("div", { className: "".concat(Navigation_1.BASE_CLASS_NAME, "__items") },
            react_1.default.createElement("div", { className: "".concat(Navigation_1.BASE_CLASS_NAME, "__item label label--large label--slate") }, "Settings")));
    };
    SettingsNavigation.prototype.renderMessage = function () {
        return (react_1.default.createElement(TrialMessage_1.default, { trial: this.props.trial, initSubscription: this.props.initSubscription, telemetry: this.props.telemetry, projectLimit: this.props.projectLimit, projectLiveLimit: this.props.projectLiveLimit }));
    };
    SettingsNavigation = __decorate([
        mobx_react_1.observer
    ], SettingsNavigation);
    return SettingsNavigation;
}(react_1.default.Component));
exports.SettingsNavigation = SettingsNavigation;
